import React from "react";
import { Helmet } from "react-helmet";
import { moment } from "../../common/common";

import cookie from "react-cookies";
import queryString from "query-string";
import { connect } from "react-redux";

import { Modal } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { isIOS } from "react-device-detect";

import { mapSdk } from "../../../model/base";

import { getLoggedProfile } from "../../../actions/sessionAct";
import {
	setFilter,
	searchCarList,
	searchCarListMore,
	searchCarMapV2,
	searchCarMapMoreV2,
} from "../../../actions/carFindingAct";
import { init, getFilterConfig, getVehicleType, getVehicleMake } from "../../../model/car";

import { commonErr } from "../../common/errors";
import { LoadingInlineTime } from "../../common/loading";
import { MessageBox, MessageLine, Empty } from "../../common/messagebox";
import WdTypeInfoBox from "../../common/wdtypeinfobox";
import { formatTitleInUrl, stypes, wdType, convertToHourText, formatTime } from "../../common/common";
import {
	parseAddressArrayToLocationArray,
	calculateDistance,
	checkWdMinHour,
	parseWdMinHour,
	getCookiesRoutes,
	setCookiesRoutes,
	is2ArrayEqual,
	getDurationTime,
	getEndDatewd,
	parseAddressToLocationWithLatLng,
	initMap,
	WDCalendarTemplate,
	WDECalendarTemplate,
} from "../../common/wdfunction";

import Header from "../../components/header";
import ListView from "../listview";
import MapView from "../mapview";
import QuicklyFilter from "../components/quicklyfilter";
import CarDetailPopup from "../cardetailpopup";

import FilterPopup from "../filterpopup";
import FilterScreen from "../filterscreen";

import QuicklySearchWD from "../components/quicklysearchwd";
import SearchFilterBox from "../components/searchfilterbox";
import SearchBox from "../components/searchbox";
import SearchSuggest from "../../common/searchsuggest";
import Login from "../../login/login";
import SignUp from "../../login/signup";

import DateBoxWD from "../../common/dateboxwd";

import {
	IcListCarFinding,
	IcMapCarFinding,
	IcLocationSearch,
	IcCalendarSearch,
	IcNextCircle,
	IcChevrDown,
	IcStartLocWD,
	IcEndLocWD,
	IcCloseOrange,
	IcPlusCGreen,
	IcCompass,
	IcQuestion,
} from "../../common/svg";

import empty from "../../../static/images/empty/empty-mycar.svg";

const viewModes = {
	LIST: 0,
	MAP: 1,
};

const defPriceRange = {
	min: 500,
	max: 10000,
	step: 100,
};

const defLimitKMRange = {
	min: 0,
	max: 550,
	step: 50,
};

const defLimitKMPriceRange = {
	min: 0,
	max: 10,
	step: 5,
};

const defDPriceRange = {
	min: 0,
	max: 50,
	step: 5,
};

const defFuelCRange = {
	min: 0,
	max: 30,
	step: 5,
};

const defYearRange = {
	min: 2000,
	max: moment().year().valueOf(),
	step: 5,
};

const defSeatRange = {
	min: 2,
	max: 16,
	step: 2,
};

const defRadiusRange = {
	min: 5,
	max: 50,
	step: 3,
};

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - (time % 60)) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

const preventDefault = (e) => e.preventDefault();

const RouteBox = ({
	show,
	onHide,
	map,
	wd,
	errMsgBox,
	hideMessageBox,
	filter,
	wdOneWay,
	isCityTourMode,
	addressArray,
	isShowWdTypeInfoBox,
	hideWdTypeInfoBox,
	onTripModeChange,
	onSelectAddress,
	onAddressChange,
	onAddressFocus,
	showWdTypeInfoBox,
	onOneWayChange,
	onAddStopPoint,
	onRemoveStopPoint,
}) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-dialog modal-route-wd">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Lộ trình</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="route-wd">
					<div className="search-option">
						<div className="search">
							<div className="wd-option-form">
								<div className="custom-radio">
									<input
										type="radio"
										id="cityTourCF"
										name="tripModeCF"
										checked={isCityTourMode && !wdOneWay}
										onChange={() => onTripModeChange({isCityTourMode: true, wdOneWay: false})}
									/>
									<label htmlFor="cityTourCF">Nội thành</label>
								</div>
								<div className="custom-radio">
									<input
										type="radio"
										id="provinceCF"
										name="tripModeCF"
										checked={!isCityTourMode && !wdOneWay}
										onChange={() => onTripModeChange({isCityTourMode: false, wdOneWay: false})}
									/>
									<label htmlFor="provinceCF">Liên tỉnh</label>
								</div>
								<div className="custom-radio">
									<input
										type="radio"
										id="provinceOneWay"
										name="tripModeCF"
										checked={!isCityTourMode && wdOneWay}
										onChange={() => onTripModeChange({isCityTourMode: false, wdOneWay: true})}
									/>
									<label htmlFor="provinceOneWay">Liên tỉnh (1 chiều)</label>
								</div>
							
							</div>
							{isCityTourMode ? (
								<div className="note">
									Di chuyển nội thành hoặc lân cận, lộ trình tự do.
									<div className="wrap-svg pointer" onClick={() => showWdTypeInfoBox(wdType.WDT_CITY_TOUR)}>
										<IcQuestion />
									</div>
								</div>
							) :  wdOneWay ? (
									<div className="note">
										Di chuyển liên tỉnh, trả khách tại điểm đến.
										<div className="wrap-svg pointer" onClick={() => showWdTypeInfoBox(wdType.WDT_ONEWAY)}>
											<IcQuestion />
										</div>
									</div>
								) : 
								
								<div className="note">
									Di chuyển liên tỉnh, trả khách về lại điểm đón.
									<div className="wrap-svg pointer" onClick={() => showWdTypeInfoBox(wdType.WDT_TWOWAY)}>
										<IcQuestion />
									</div>
								</div>
							}
							<div id="mapWD" ref={map} className="wrap-map" />
							{isCityTourMode ? (
								<div className="search-form">
									<div className="search-form__item">
										<div className="title">
											<div className="wrap-svg">
												<IcLocationSearch />
											</div>
											<p>Điểm đón</p>
										</div>
										<div className="choose">
											<div className="choose-item has-arrow">
												<SearchSuggest
													inputProps={{
														value: addressArray[0],
														onChange: (address) => onAddressChange(address, 0),
														// onFocus: (e) => onAddressFocus(e, 0),
														placeholder: "Tôi muốn đón tại...",
													}}
													onSelect={(address) => onSelectAddress(address, 0)}
												/>
											</div>
										</div>
									</div>
								</div>
							) : wdOneWay ?  
							(
								<>
									{addressArray.map((address, i) => (
										<div className="search-form" key={i}>
											<div className="search-form__item">
												<div className="title">
													<div className="wrap-svg">{i === 0 ? <IcStartLocWD /> : <IcEndLocWD />}</div>
													<p>{i === 0 ? "Điểm đón" : "Điểm đến"}</p>
												</div>
												<div className="choose">
													<div className={`choose-item ${i === 0 || i === 1 ? "" : "has-remove"}`}>
														<SearchSuggest
															focusAddress={true}
															inputProps={{
																value: address,
																onChange: (address) => onAddressChange(address, i),
																// onFocus: (e) => onAddressFocus(e, i),
															}}
															onSelect={(address) => onSelectAddress(address, i)}
														/>

														{!(i === 0 || i === 1) && (
															<div className="wrap-svg" onClick={() => onRemoveStopPoint(i)}>
																<IcCloseOrange />
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									))}
									{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
										<div className="search-form">
											<div className="search-form__item" onClick={onAddStopPoint}>
												<div className="title add">
													<div className="wrap-svg">
														<IcPlusCGreen />
													</div>
													<p>Thêm điểm đến</p>
												</div>
											</div>
										</div>
									)}
								</>
							)
							: (
								<>
									{addressArray.map((address, i) => (
										<div className="search-form" key={i}>
											<div className="search-form__item">
												<div className="title">
													<div className="wrap-svg">{i === 0 ? <IcStartLocWD /> : <IcEndLocWD />}</div>
													<p>{i === 0 ? "Điểm đón" : "Điểm đến"}</p>
												</div>
												<div className="choose">
													<div className={`choose-item ${i === 0 || i === 1 ? "" : "has-remove"}`}>
														<SearchSuggest
															focusAddress={true}
															inputProps={{
																value: address,
																onChange: (address) => onAddressChange(address, i),
																// onFocus: (e) => onAddressFocus(e, i),
															}}
															onSelect={(address) => onSelectAddress(address, i)}
														/>

														{!(i === 0 || i === 1) && (
															<div className="wrap-svg" onClick={() => onRemoveStopPoint(i)}>
																<IcCloseOrange />
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									))}
									{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
										<div className="search-form">
											<div className="search-form__item no-line" onClick={onAddStopPoint}>
												<div className="title add">
													<div className="wrap-svg">
														<IcPlusCGreen />
													</div>
													<p>Thêm điểm đến</p>
												</div>
											</div>
										</div>
									)}
									
								</>
							)}

							{!addressArray.includes("") && wd && (
								<div className="note-route">
									{wd.distanceInKM > 0 && filter.wdDistance > 0 && !isCityTourMode ? (
										<div className="note-route__item">
											<p>Tổng lộ trình</p>
											<p>{wd.distanceInKM.toFixed(1)} km</p>
										</div>
									) : null}
									{wd.limitKM > 0 && (
										<div className="note-route__item">
											<p>Số km được đi</p>
											<p>{wd.limitKM} km</p>
										</div>
									)}
								</div>
							)}

							<a
								className="btn btn-primary btn--s"
								disabled={isCityTourMode ? addressArray[0] == "" : addressArray.includes("")}
								onClick={onHide}>
								Tìm xe ngay
							</a>
						</div>
					</div>
				</div>

				<WdTypeInfoBox show={isShowWdTypeInfoBox} hideModal={hideWdTypeInfoBox} />
				<MessageBox show={errMsgBox !== ""} hideModal={hideMessageBox} message={errMsgBox} />
			</Modal.Body>
		</Modal>
	);
};

class CarFindingWD extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			errMsgBox: "",
			addressPlaceHolder:
				this.props.carFinding.filter.address !== "" ? this.props.carFinding.filter.address : "Vị trí trên bản đồ.",

			viewMode: viewModes.LIST,
			isOpenFilterBox: false,
			isOpenFilter: false,
			isShowAdvance: false,
			isShowPopup: false,
			popupCarId: "",
			isOpenSearching: false,
			showSearchTime: true,

			location: props.location,
			oriUrl: window.location.href,
			// wd
			locAddress: [],
			markerArr: [],
			startLocation: null,
			endLocation: null,
			directionsService: null,
			directionsRenderer: null,
			isOpenAddressBox: false,
			addressArray: ["Hồ Chí Minh", ""],
			isCityTourMode: true,
			wdOneWay: false,
			deliveryAddressChangedFlag: false,
			isSelectHour: false,
			// gmapLoaded: false,
			visible: true,
			visibleBottom: true,
			fixHeight: false,
			isDateBox: false,
			indexUrl: -1,
			prevUrl: ""
		};
		this.stype = stypes.WD;
		this.isSD = false;
		this.prevScrollPos = window.scrollY;
		this.visible = true;
		this.visibleBottom = true;
		this.timeoutScroll = null;

		this.wrapperSelect = React.createRef();
		this.wrapperSelectCF = React.createRef();
		this.map = React.createRef();
	}

	componentDidMount() {

		// if (window.history && window.history.length < 3) {
		// 	this.setState({
		// 		indexUrl: 1
		// 	})
		// }

		if (window.history.state?.prevUrl) {
			this.setState({
				prevUrl: window.history.state?.prevUrl
			})
		}


		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);
			// if (query.summer_game) {
			// 	cookie.save("_summer_game", query.summer_game, { path: "/" });
			// 	cookie.save("_summer_game", query.summer_game, { path: "/", domain: ".mioto.vn" });
			// } else {
			// 	cookie.remove("_summer_game", { path: "/" });
			// 	cookie.remove("_summer_game", { path: "/", domain: ".mioto.vn" });
			// }
			// if (query.wauth) {
			// 	cookie.save("_wauth_game", query.wauth_game, { path: "/" });
			// 	cookie.save("_wauth_game", query.wauth_game, { path: "/", domain: ".mioto.vn" });
			// }
		}
		init().then((initResp) => {
			this.setState({
				initResp: initResp.data.data,
			});

			getFilterConfig().then((filterConfigResp) => {
				if (filterConfigResp.data.data) {
					this.setState({
						customFilterConfig: filterConfigResp.data.data,
					});
				}

				this.wdMinHour = parseWdMinHour(
					initResp.data.data.wdMinHourCT,
					initResp.data.data.wdMinHour,
					initResp.data.data.wdMinHourOW
				);

				if (this.props.carFinding.filter.isOpenSearching) {
					this.setState({
						isOpenSearching: false,
					});
				}

				if (!cookie.load("_mstarttswd") || !cookie.load("_mendtswd") || !cookie.load("_mmintswd")) {
					cookie.remove("_mstarttswd", { path: "/" });
					cookie.remove("_mendtswd", { path: "/" });
					cookie.remove("_mmintswd", { path: "/" });
				}

				// check valid cookie before set
				const isTimeCookieValueValidwd =
					cookie.load("_mstarttswd") < moment().add(1, "hours").valueOf() ||
					cookie.load("_mendtswd") < moment().add(1, "hours").valueOf() ||
					cookie.load("_mmintswd");
				if (isTimeCookieValueValidwd) {
					cookie.remove("_mstarttswd", { path: "/" });
					cookie.remove("_mendtswd", { path: "/" });
					cookie.remove("_mmintswd", { path: "/" });
				}

				var addressArray = ["Hồ Chí Minh", ""];
				var isCityTourMode = true;
				var wdOneWay = false;
				var startDate;
				var endDate;
				var startTime;
				var endTime;
				var durationTimeArr;
				var selectHour;
				var isAirDelivery = false;
				var deliveryId;
				var vehicleType;
				var vehicleMake;
				var unknowDate = false;

				//overide filter by query params
				if (this.props.location && this.props.location.search) {
					const query = queryString.parse(this.props.location.search);

					if (query.startDate) {
						startDate = moment(query.startDate * 1);
						startTime = startDate.get("hour") * 60 + startDate.get("minute");
					}
					if (query.endDate) {
						endDate = moment(query.endDate * 1);
						endTime = endDate.get("hour") * 60 + endDate.get("minute");
					}

					if (query.address) {
						addressArray = query.address.split(";");
					}

					if (query.isCityTourMode) {
						isCityTourMode = query.isCityTourMode === "true" ? true : false;
					}

					if (query.isOneWay) {
						wdOneWay = query.isOneWay === "true" ? true : false;
					}

					if (query.selectHour) {
						selectHour = query.selectHour * 1;
					}

					if (query.isAirDelivery) {
						isAirDelivery = query.isAirDelivery;
					}

					if (query.deliveryId) {
						deliveryId = query.deliveryId;
					}

					if (query.vtype) {
						vehicleType = query.vtype.split(";");
					}

					if (query.vmake) {
						vehicleMake = query.vmake * 1;
					}

					//GA tracking
					if (query.utm_source) {
						cookie.save("_utm_src", query.utm_source, { path: "/" });
						cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
					}
					if (query.utm_ext) {
						cookie.save("_utm_ext", query.utm_ext, { path: "/" });
						cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
					} else {
						cookie.remove("_utm_ext", { path: "/" });
						cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
					}
				} 
				this.setState({
					isAirDelivery: isAirDelivery,
				});

				let wdMinHour = isCityTourMode
					? initResp.data.data.wdMinHourCT
					: wdOneWay
					? initResp.data.data.wdMinHourOW
					: initResp.data.data.wdMinHour;
				let gDurationTime = getDurationTime(isCityTourMode, wdMinHour, 0);
				let cDurTimeArr = gDurationTime;
				cDurTimeArr.unshift(4);
				durationTimeArr = wdOneWay ? cDurTimeArr : gDurationTime;

				const cStartTs = cookie.load("_mstarttswd");
				if (cStartTs) {
					const cStartDate = moment(cStartTs * 1);
					startDate = cStartDate;
					startTime = startDate.get("hour") * 60 + startDate.get("minute");
				}

				const cMinTs = cookie.load("_mmintswd") * 1;
				if (cMinTs) {
					selectHour = cMinTs;
				}

				const cEndTs = cookie.load("_mendtswd");
				if (cEndTs) {
					// endDate = moment(cEndTs * 1);
					// endTime = endDate.get("hour") * 60 + endDate.get("minute");
					endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cEndTs * 1);
					endTime = endDate.get("hour") * 60 + endDate.get("minute");
				}

				if (!startDate && !endDate) {
					const timeInit = initResp.data.data;
					if (timeInit) {
						startDate = moment(timeInit.wdStartTime);
						startTime = moment(timeInit.wdStartTime).get("hour") * 60 + moment(timeInit.wdStartTime).get("minute");
						endDate = getEndDatewd(durationTimeArr[0], startDate);
						endTime = endDate.get("hour") * 60 + endDate.get("minute");
						selectHour = durationTimeArr[0];
						unknowDate = true;
					}
					if (addressArray) {
						this.setState({
							addressBanner: addressArray[0] !== "" && addressArray[0],
						});
					}
				}
				cookie.save("_mstarttswd", startDate.valueOf(), { path: "/" });
				cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });
				cookie.save("_mmintswd", selectHour, { path: "/" });

				const filter = {
					...this.props.carFinding.filter,
					startDate: startDate,
					endDate: endDate,
					startTime: startTime,
					endTime: endTime,
					stype: stypes.WD,
					minPrice: 100,
					maxPrice: 20000,
					dPrice: defDPriceRange.max,
					durationTimeArr: durationTimeArr,
					selectHour: selectHour,
					deliveryId: isAirDelivery ? deliveryId : undefined,
					vehicleType: vehicleType ? vehicleType : undefined,
					vehicleMake: vehicleMake ? vehicleMake : 0,
				};
				this.setFilter(filter);
				this.setState({
					startDate: startDate,
					endDate: endDate,
					startTime: startTime,
					endTime: endTime,
					baseFilter: { ...filter },
					durationTimeArr: durationTimeArr,
					selectHour: selectHour,
				});
				/*
						- Priority use:
						+ cookies
						+ query params
						+ default values
					*/
				// Use cookies
				const cRoutes = getCookiesRoutes();

				if (
					cRoutes &&
					is2ArrayEqual(cRoutes.addressArray, addressArray) &&
					cRoutes.isCityTourMode === isCityTourMode &&
					cRoutes.wdOneWay === wdOneWay
				) {
					const {
						isCityTourMode,
						wdOneWay,
						addressArray,
						locationArray,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
						deliveryAddressChangedFlag,
					} = cRoutes;
					let wdMinHour = isCityTourMode
						? initResp.data.data.wdMinHourCT
						: wdOneWay
						? initResp.data.data.wdMinHourOW
						: initResp.data.data.wdMinHour;
					let { wdLocations } = cRoutes;

					// getDirectionsResponse(wdOneWay, isCityTourMode ? [locationArray[0]] : locationArray, (directionsResponse) => {
					// 	this.setState({ directionsResponse })
					// })

					if (addressArray.length === 1) {
						addressArray.push("");
						locationArray.push(undefined);
					}
					this.setState({
						isCityTourMode,
						addressArray,
						locationArray,
						wdLocations,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
						deliveryAddressChangedFlag,
					});

					if (isCityTourMode) {
						// city tour

						// let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, 0, startDate, endDate, this.wdMinHour)
						durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
						selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
						endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

						this.setState({
							locAddress: [locationArray[0]],
							durationTimeArr,
							selectHour,
							endDate,
							endTime: endDate.get("hour") * 60 + endDate.get("minute"),
						});

						const filter = {
							...this.props.carFinding.filter,
							lat: locationArray[0].lat,
							lng: locationArray[0].lng,
							address: addressArray[0],
							wdLocations: wdLocations.split(",")[0],
							wdDistance: 0,
							wdOneWay,
							wdDistanceBackOW,
							durationTimeArr,
							selectHour,
							endDate,
							endTime: endDate.get("hour") * 60 + endDate.get("minute"),
						};

						this.setFilter(filter);
						this.searchCar(filter);
					} else {
						// across province
						// let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDate, endDate, this.wdMinHour)

						durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
						selectHour = (durationTimeArr[1] != selectHour) & !unknowDate ? selectHour : durationTimeArr[1];
						endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

						this.setState({
							// wdMinHourDetected,
							locAddress: locationArray,
							durationTimeArr,
							selectHour,
							endDate,
							endTime: endDate.get("hour") * 60 + endDate.get("minute"),
						});

						const filter = {
							...this.props.carFinding.filter,
							lat: locationArray[0].lat,
							lng: locationArray[0].lng,
							wdLocations,
							wdDistance,
							wdOneWay,
							wdDistanceBackOW,
							durationTimeArr,
							selectHour,
							endDate,
							endTime: endDate.get("hour") * 60 + endDate.get("minute"),
						};

						this.setFilter(filter);
						this.searchCar(filter);
					}
				}
				// Use query params
				else if (!addressArray.includes("")) {
				
					parseAddressArrayToLocationArray(addressArray, (locationArray) => {
						// getDirectionsResponse(wdOneWay, isCityTourMode ? [locationArray[0]] : locationArray, (directionsResponse) => {
						// 	this.setState({ directionsResponse })
						// })
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							const deliveryAddressChangedFlag = false;

							
							// format wdLocations
							let wdLocations = "";
							for (let i = 0; i < addressArray.length; i++) {
								wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
									"base64"
								)}${i !== addressArray.length - 1 ? "," : ""}`;
							}
							if (addressArray.length === 1) {
								addressArray.push("");
								locationArray.push(undefined);
							}
							this.setState({
								isCityTourMode,
								addressArray,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								deliveryAddressChangedFlag,
							});

							setCookiesRoutes({
								isCityTourMode,
								wdOneWay,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								wdLocations,
								deliveryAddressChangedFlag,
							});

							let wdMinHour = isCityTourMode
								? initResp.data.data.wdMinHourCT
								: wdOneWay
								? initResp.data.data.wdMinHourOW
								: initResp.data.data.wdMinHour;

							if (isCityTourMode) {
								// city tour
								// let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, 0, startDate, endDate, this.wdMinHour)

								durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
								selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
								endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

								this.setState({
									// wdMinHourDetected,
									locAddress: [locationArray[0]],
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								});
								const filter = {
									...this.props.carFinding.filter,
									lat: locationArray[0].lat,
									lng: locationArray[0].lng,
									wdLocations: wdLocations.split(",")[0],
									wdDistance: 0,
									wdOneWay,
									wdDistanceBackOW,
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								};

								this.setFilter(filter);
								this.searchCar(filter);
							} else {
								// across province
								// let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDate, endDate, this.wdMinHour)
							
								durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
								selectHour = (durationTimeArr[1] !== selectHour) & !unknowDate ? selectHour : durationTimeArr[1];
								endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

								this.setState({
									// wdMinHourDetected,
									locAddress: locationArray,
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								});
								const filter = {
									...this.props.carFinding.filter,
									lat: locationArray[0].lat,
									lng: locationArray[0].lng,
									wdLocations,
									wdDistance,
									wdOneWay,
									wdDistanceBackOW,
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								};

								this.setFilter(filter);
								this.searchCar(filter);
							}
						});
					});
					return;
				} else {
					// Use default values (Mode: citytour)
				
					if (addressArray[0] === "") {
					addressArray = ["Hồ Chí Minh"];
					isCityTourMode = true;
					wdOneWay = false;
					parseAddressArrayToLocationArray(addressArray, (locationArray) => {
						// getDirectionsResponse(wdOneWay, isCityTourMode ? [locationArray[0]] : locationArray, (directionsResponse) => {
						// 	this.setState({ directionsResponse })
						// })
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							const deliveryAddressChangedFlag = false;
							// format wdLocations
							let wdLocations = "";
							for (let i = 0; i < addressArray.length; i++) {
								wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
									"base64"
								)}${i !== addressArray.length - 1 ? "," : ""}`;
							}
							if (addressArray.length === 1) {
								addressArray.push("");
								locationArray.push(undefined);
							}


							// city tour
							// let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, 0, startDate, endDate, this.wdMinHour)
							let wdMinHour = isCityTourMode
								? initResp.data.data.wdMinHourCT
								: wdOneWay
								? initResp.data.data.wdMinHourOW
								: initResp.data.data.wdMinHour;
							durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
							selectHour = (durationTimeArr[1] !== selectHour) & !unknowDate ? selectHour : durationTimeArr[1];
							endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

							this.setState({
								// wdMinHourDetected,
								isCityTourMode,
								addressArray,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								deliveryAddressChangedFlag,
								locAddress: [locationArray[0]],
								durationTimeArr,
								selectHour,
								endDate,
								endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								wdOneWay: false,
							});

							setCookiesRoutes({
								isCityTourMode,
								wdOneWay,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								wdLocations,
								deliveryAddressChangedFlag,
							});

							const filter = {
								...this.props.carFinding.filter,
								lat: locationArray[0].lat,
								lng: locationArray[0].lng,
								wdLocations: wdLocations.split(",")[0],
								wdDistance: 0,
								wdOneWay,
								wdDistanceBackOW,
								durationTimeArr,
								selectHour,
								endDate,
								endTime: endDate.get("hour") * 60 + endDate.get("minute"),
							};
							this.setFilter(filter);
							this.searchCar(filter);
						});
					});
					} 
				}

				// if (startDate < moment().add(1, "hours").valueOf() || endDate < moment().add(1, "hours").valueOf()) {
				// 	this.setState({
				// 		err: commonErr.FAIL,
				// 		errMsg: "Thời gian tìm kiếm không hợp lệ."
				// 	});
				// }
			});
		});

		getFilterConfig().then((resp) => {
			if (resp.data.data) {
				this.setState({
					customFilterConfig: resp.data.data,
				});
			}
		});

		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});

		getVehicleMake().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleMakes: resp.data.data.vehicleMakes,
				});
			}
		});

		window.addEventListener("click", this.handleClick);
		// this.initMap()
		window.addEventListener("scroll", this.handleScroll);

		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga('send', 'event', utmSrc, "CAR_FINDING_BETA", utmExt);
		window.gtag("event", "CAR_FINDING", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
		window.fbq("track", "CAR_FINDING");
	}

	UNSAFE_componentWillUnmount() {
		// important
		document.removeEventListener("click", this.handleClick);
		window.removeEventListener("scroll", this.handleScroll);
	}

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	initMap = () => {
		const { wdOneWay } = this.props.carFinding.filter;
		const { locAddress } = this.state;

		if (locAddress.length > 0) {
			setTimeout(() => {
				initMap(wdOneWay, this.map, locAddress, true, "", 2);
			}, 1000);
		}
	};

	onFixHeight = (fix) => {
		this.setState({
			fixHeight: fix,
		});
	};

	handleScroll = () => {
		const currentScrollPos = window.scrollY;
		this.visible = currentScrollPos < 89; //Height of Header
		this.visibleBottom = currentScrollPos < 89 || this.prevScrollPos > currentScrollPos;

		// clearTimeout(this.timeoutScroll);
		// if (currentScrollPos < this.prevScrollPos) {
		// 	this.timeoutScroll = setTimeout(() => {
		// 		this.visible = true;
		// 		this.setState({
		// 			visible: this.visible,
		// 		});
		// 		this.visibleBottom = true;
		// 		this.setState({
		// 			visibleBottom: this.visibleBottom,
		// 		});
		// 	}, 1000);
		// }

		// Header and filter
		if (this.visible !== this.state.visible && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visible: this.visible,
			});
		}

		//Show map button
		if (this.visibleBottom !== this.state.visibleBottom && this.state.viewMode === viewModes.LIST) {
			this.setState({
				visibleBottom: this.visibleBottom,
			});
		}

		this.prevScrollPos = currentScrollPos;
	};

	//common
	handleClick = (event) => {
		const { target } = event;
		if (target !== null && this.wrapperSelectCF.current !== null && !this.wrapperSelectCF.current.contains(target)) {
			const { isSelectHour } = this.state;
			if (isSelectHour) {
				this.setState({
					isSelectHour: false,
				});
			}
		}
	};

	setListView = () => {
		this.setState({
			viewMode: viewModes.LIST,
		});
		this.searchCarList(this.props.carFinding.filter);
	};

	setMapView = () => {
		this.setState({
			viewMode: viewModes.MAP,
		});
	};

	toggleFilterBox = () => {
		this.setState({
			isOpenFilterBox: !this.state.isOpenFilterBox,
		});
	};

	hideFilterBox = () => {
		this.setState({
			isOpenFilterBox: false,
		});
	};

	toggleFilter = () => {
		this.setState({
			isOpenFilter: !this.state.isOpenFilter,
		});
	};

	hideFilter = () => {
		this.setState({
			isOpenFilter: false,
		});
	};

	setFilter = (filter) => {
		this.props.dispatch(setFilter(filter));
	};

	resetFilter = () => {
		let filter;

		// WD
		const {
			startDate,
			endDate,
			lat,
			lng,
			minMiles,
			wdLocations,
			wdDistance,
			wdDistanceOW,
			wdDistanceBackOW,
			wdOneWay,
			durationTimeArr,
			selectHour,
			vehicleModel,
		} = this.props.carFinding.filter;
		filter = {
			...this.state.baseFilter,
			startDate,
			endDate,
			lat,
			lng,
			minMiles,
			wdLocations,
			wdDistance,
			wdDistanceOW,
			wdDistanceBackOW,
			wdOneWay,
			durationTimeArr,
			selectHour,
			vehicleMake: 0,
			vehicleModel: [],
			ownerHostFiveStar: 0,
			dPrice: defDPriceRange.max,
		};

		this.setFilter(filter);

		const { vehicleTypes } = this.state;

		for (let i = 0; i < vehicleTypes.length; ++i) {
			vehicleTypes[i].checked = false;
		}

		const allFeatures = this.state.customFilterConfig.allFeatures;
		for (var i = 0; i < allFeatures.length; ++i) {
			allFeatures[i].checked = false;
		}

		this.searchCar(filter);
	};

	searchCarList = (f) => {
		const filter = this.standarizeFilter(f, viewModes.LIST);

		this.props.dispatch(searchCarList(filter));
	};

	searchCarListMore = (f) => {
		const filter = this.standarizeFilter(f, viewModes.LIST);
		this.props.dispatch(searchCarListMore(filter));
	};

	searchCarMap = (f) => {
		const filter = this.standarizeFilter(f, viewModes.MAP);
		// this.props.dispatch(searchCarMap(filter));
		this.props.dispatch(searchCarMapV2(filter));
	};

	searchCarMapMore = (f) => {
		const filter = this.standarizeFilter(f, viewModes.MAP);
		// this.props.dispatch(searchCarMapMore(filter));
		this.props.dispatch(searchCarMapMoreV2(filter));
	};

	standarizeFilter = (filter, viewMode) => {
		const customFilterConfig = this.state.customFilterConfig;
		const maxPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxPrice
				? customFilterConfig.maxPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxPrice
			? customFilterConfig.wdMaxPrice / 1000
			: defPriceRange.max;
		const minPrice = this.isSD
			? customFilterConfig && customFilterConfig.minPrice
				? customFilterConfig.minPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMinPrice
			? customFilterConfig.wdMinPrice / 1000
			: defPriceRange.min;
		const maxDPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxDeliveryPrice
				? customFilterConfig.maxDeliveryPrice / 1000
				: defDPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxDeliveryPrice
			? customFilterConfig.wdMaxDeliveryPrice / 1000
			: defDPriceRange.max;
		//
		const minLimitKM =
			customFilterConfig && customFilterConfig.minLimitKM ? customFilterConfig.minLimitKM : defLimitKMRange.min;
		const maxLimitKM =
			customFilterConfig && customFilterConfig.maxLimitKM ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice =
			customFilterConfig && customFilterConfig.maxLimitKMPrice
				? customFilterConfig.maxLimitKMPrice / 1000 + 5
				: defLimitKMPriceRange.max;
		const minFuelC =
			customFilterConfig && customFilterConfig.minFuelC ? customFilterConfig.minFuelC : defFuelCRange.min;
		const maxFuelC =
			customFilterConfig && customFilterConfig.maxFuelC ? customFilterConfig.maxFuelC : defFuelCRange.max;
		const minSeat = customFilterConfig && customFilterConfig.seatMin ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = customFilterConfig && customFilterConfig.seatMax ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = customFilterConfig && customFilterConfig.yearMin ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = customFilterConfig && customFilterConfig.yearMax ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius =
			customFilterConfig && customFilterConfig.maxRadius ? customFilterConfig.maxRadius : defRadiusRange.max;

		return {
			...filter,
			minPrice: filter.minPrice > minPrice ? filter.minPrice : 0,
			maxPrice: filter.maxPrice < maxPrice ? filter.maxPrice : 0,
			dPrice: filter.dPrice < maxDPrice
				? filter.dPrice
				: -1,
			limitKM: filter.limitKM < maxLimitKM ? filter.limitKM : -1,
			limitKMPrice: filter.limitKM > minLimitKM && filter.limitKMPrice < maxLimitKMPrice ? filter.limitKMPrice : -1,
			fuelC: filter.fuelC > minFuelC && filter.fuelC < maxFuelC ? filter.fuelC : 0,
			minSeat: filter.minSeat > minSeat && filter.minSeat < maxSeat ? filter.minSeat : 0,
			maxSeat: filter.maxSeat > minSeat && filter.maxSeat < maxSeat ? filter.maxSeat : 0,
			minYear: filter.minYear > minYear && filter.minYear < maxYear ? filter.minYear : 0,
			maxYear: filter.maxYear > minYear && filter.maxYear < maxYear ? filter.maxYear : 0,
			radius: viewMode === viewModes.LIST && filter.radius * 1.60934 >= maxRadius ? 0 : filter.radius,
		};
	};

	searchCar = (filter) => {
		if (this.state.viewMode === viewModes.MAP) {
			this.searchCarMap(filter);
		} else {
			this.searchCarList(filter);
		}
	};

	setAddressPlaceHolder = (msg) => {
		this.setState({
			addressPlaceHolder: msg,
		});
	};

	onAddressChange = (address, i) => {
		const addressArray = [...this.state.addressArray];
		addressArray[i] = address;
		this.setState({
			addressArray,
		});
	};

	onAddressFocus = (e, i) => {
		const addressArray = [...this.state.addressArray];
		addressArray[i] = "";
		const locationArray = [...this.state.locationArray];
		locationArray[i] = undefined;
		this.setState({
			addressArray,
			locationArray,
		});
	};

	onSelectAddress = (address, i) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Trình duyệt không được cho phép truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
			this.showMessageBox(errMsg);
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			const { isCityTourMode, startDate, endDate, initResp, isAirDelivery } = this.state;
			const { wdOneWay } = this.props.carFinding.filter;
			let { deliveryId } = this.props.carFinding.filter;
			const wdMinHour = isCityTourMode ? initResp.wdMinHourCT : wdOneWay ? initResp.wdMinHourOW : initResp.wdMinHour;
			const addressArray = [...this.state.addressArray];
			addressArray[i] = address.address;

			if (i === 0 && isAirDelivery && deliveryId) {
				deliveryId = undefined;
				this.setState({
					isAirDelivery: false,
				});
			}

			// parse location
			parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (location) => {
				const locationArray = [...this.state.locationArray];
				locationArray[i] = location;

				if (isCityTourMode) {
					// city tour
					this.calculateAndDisplayRoute([locationArray[0]]);
					const cwdLocationsArray = this.state.wdLocations.split(",");
					cwdLocationsArray[0] =
						locationArray[0].lat + "-" + locationArray[0].lng + "-" + Buffer.from(address.address).toString("base64");
					const wdLocations = cwdLocationsArray.join(",");

					this.setState({
						err: commonErr.SUCCESS,
						addressArray,
						locationArray,
						wdLocations,
						deliveryAddressChangedFlag: true,
					});

					setCookiesRoutes({ wdLocations, deliveryAddressChangedFlag: true });

					this.setState({
						locAddress: [locationArray[0]],
					});
					const filter = {
						...this.props.carFinding.filter,
						lat: locationArray[0].lat,
						lng: locationArray[0].lng,
						wdLocations: wdLocations.split(",")[0],
						wdDistance: 0,
						deliveryId,
					};

					this.setFilter(filter);
					this.searchCar(filter);
				} else {
					// across province
					if (addressArray.includes("")) {
						const locAddress = this.state.locAddress;
						locAddress[0] = locationArray[0];
						this.calculateAndDisplayRoute(locAddress);

						this.setState({
							addressArray,
							locationArray,
						});
					} else {
						this.calculateAndDisplayRoute(locationArray);
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							// format wdLocations
							let wdLocations = "";
							for (let i = 0; i < addressArray.length; i++) {
								wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
									"base64"
								)}${i !== addressArray.length - 1 ? "," : ""}`;
							}

							this.setState({
								err: commonErr.SUCCESS,
								addressArray,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
							});
							setCookiesRoutes({ wdDistance, wdDistanceOW, wdDistanceBackOW, wdLocations });

							// across province
							let wdMinHourDetected = checkWdMinHour(
								isCityTourMode,
								wdOneWay,
								wdDistance,
								startDate,
								endDate,
								this.wdMinHour
							);

							const time = this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);

							this.setState({
								selectHour: time.selectHour,
								durationTimeArr: time.durationTimeArr,
								endDate: time.endDate,
								endTime: time.endTime,
							});

							const filter = {
								...this.props.carFinding.filter,
								selectHour: time.selectHour,
								durationTimeArr: time.durationTimeArr,
								endDate: time.endDate,
								endTime: time.endTime,
								lat: locationArray[0].lat,
								lng: locationArray[0].lng,
								wdLocations,
								wdDistance,
								wdDistanceBackOW,
								deliveryId,
							};

							cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
							cookie.save("_mmintswd", time.selectHour, { path: "/" });

							this.setState({
								locAddress: locationArray,
							});

							this.setFilter(filter);
							this.searchCar(filter);
						});
					}
				}
			});
		}
	};

	onStartDateChange = (date) => {
		// event.preventDefault();

		const { selectHour } = this.props.carFinding.filter;
		if (date) {
			const startDate = date;
			var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
			// var endTime = endDate.get("hour") * 60 + endDate.get("minute");
			// var hour = this.state.startTime ? (this.state.startTime - this.state.startTime % 60) / 60 : (this.props.carFinding.filter.startTime - this.props.carFinding.filter.startTime % 60) / 60;
			// var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;
			startDate.set({
				hour: startDate.get("hour"),
				minute: startDate.get("minute"),
				second: 0,
				milliseconds: 0,
			});

			if (endDate <= startDate) {
				endDate = startDate
					.clone()
					.add(1, "days")
					.set({
						hour: endDate.get("hour"),
						minute: endDate.get("minute"),
						second: 0,
						milliseconds: 0,
					});
			}

			if (selectHour > 0) {
				endDate = getEndDatewd(selectHour, startDate);
			}

			// save cookies
			cookie.save("_mstarttswd", startDate.valueOf(), { path: "/" });
			cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });

			this.setState({
				startDate: startDate,
				endDate: endDate,
			});

			// this.toogleSearchTime();
			const filter = {
				...this.props.carFinding.filter,
				startDate: startDate,
				endDate: endDate,
				isOpenSearching: true,
			};

			this.setFilter(filter);
			this.searchCar(filter);

			// this.toogleSearchTime();
		}
	};

	onEndDateChange = (date) => {
		// event.preventDefault();

		if (date) {
			const startDate = this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate;
			// startDate.set({
			// 	hour: startDate.get("hour"),
			// 	minute: startDate.get("minute"),
			// 	second: 0,
			// 	milliseconds: 0
			// });
			const endDate = date;
			endDate.set({
				hour: endDate.get("hour"),
				minute: endDate.get("minute"),
				second: 0,
				milliseconds: 0,
			});
			if (endDate <= startDate) {
				return;
			}
			// save cookies
			cookie.save("_mstarttswd", startDate.valueOf(), { path: "/" });
			cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });

			this.setState({
				startDate: startDate,
				endDate: endDate,
			});

			const filter = {
				...this.props.carFinding.filter,
				startDate: startDate,
				endDate: endDate,
				isOpenSearching: true,
			};

			this.setFilter(filter);
			// WD
			const wdMinHourDetected = checkWdMinHour(
				this.state.isCityTourMode,
				this.props.carFinding.filter.wdOneWay,
				this.props.carFinding.filter.wdDistance,
				startDate,
				endDate,
				this.wdMinHour
			);
			this.setState({
				wdMinHourDetected,
			});
			if (!wdMinHourDetected) {
				this.searchCar(filter);
			}
		}
	};

	onStartTimeChange = (time) => {
		// const time = event.target.value;
		const hour = (time - (time % 60)) / 60;
		const min = time % 60;
		var startDate = moment(
			this.state.startDate ? this.state.startDate : this.this.props.carFinding.filter.startDate
		).set({
			hour: hour,
			minute: min,
			second: 0,
			milliseconds: 0,
		});

		var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
		if (endDate && endDate.isValid() && endDate <= startDate) {
			endDate = startDate.clone().add(23, "hour");
		}

		const { selectHour } = this.props.carFinding.filter;
		if (selectHour > 0) {
			endDate = getEndDatewd(selectHour, startDate);
		}
		// save cookies
		cookie.save("_mstarttswd", startDate.valueOf(), { path: "/" });
		cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });

		this.setState({
			startDate: startDate,
			startTime: startDate.get("hour") * 60 + startDate.get("minute"),
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
			err: commonErr.SUCCESS,
			errMsg: "",
		});

		const filter = {
			...this.props.carFinding.filter,
			startDate: startDate,
			endDate: endDate,
			isOpenSearching: true,
		};
		this.setFilter(filter);
		this.searchCar(filter);
	};

	onEndTimeChange = (time) => {
		// const time = event.target.value;
		const hour = (time - (time % 60)) / 60;
		const min = time % 60;
		var endDate = moment(this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate).set({
			hour: hour,
			minute: min,
			second: 0,
			milliseconds: 0,
		});

		var startDate = this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate;
		if (startDate && startDate.isValid() && endDate <= startDate) {
			startDate = endDate.clone().add(-23, "hour");
		}
		// save cookies
		cookie.save("_mstarttswd", startDate.valueOf(), { path: "/" });
		cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });

		this.setState({
			startDate: startDate,
			startTime: startDate.get("hour") * 60 + startDate.get("minute"),
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
			err: commonErr.SUCCESS,
			errMsg: "",
		});

		const filter = {
			...this.props.carFinding.filter,
			startDate: startDate,
			endDate: endDate,
			isOpenSearching: true,
		};

		this.setFilter(filter);

		// WD
		const wdMinHourDetected = checkWdMinHour(
			this.state.isCityTourMode,
			this.props.carFinding.filter.wdOneWay,
			this.props.carFinding.filter.wdDistance,
			startDate,
			endDate,
			this.wdMinHour
		);
		this.setState({
			wdMinHourDetected,
		});
		if (!wdMinHourDetected) {
			this.searchCar(filter);
		}
	};

	showMessageBox = (msg) => {
		this.setState({
			errMsgBox: msg,
		});
	};

	hideMessageBox = () => {
		this.setState({
			errMsgBox: "",
		});
	};

	showWdTypeInfoBox = (wdType) => {
		this.setState({
			isShowWdTypeInfoBox: true,
			wdType,
		});
	};

	hideWdTypeInfoBox = () => {
		this.setState({
			isShowWdTypeInfoBox: false,
		});
	};

	togglePopup = (car, isUpdate) => {
		const { isAirDelivery } = this.state;
		const state = { deliveryId: this.props.carFinding.filter.deliveryId };

		if (isUpdate === true) {
			window.history.pushState(state, "", `/car/${this.isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`);
			this.setState({
				popupCarId: car.id,
				// indexUrl: -3,
			});
		} else {
			if (!this.state.isShowPopup) {
				window.history.pushState(state, "", `/car/${this.isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`);
				// this.setState({
				// 	indexUrl: -3,
				// })
			} else {
				window.history.pushState(state, "", this.state.oriUrl);
				// this.setState({
				// 	indexUrl: -1,
				// })
			}
			this.setState({
				isShowPopup: !this.state.isShowPopup,
				popupCarId: car.id,
			});
		}
	};

	onHidePopup = () => {
		this.setState({
			isShowPopup: false,
		});
	};

	showAdvance = () => {
		this.setState({
			isShowAdvance: true,
		});
	};

	hideAdvance = () => {
		this.setState({
			isShowAdvance: false,
		});
	};

	hasFilter = (filter, customFilterConfig) => {
		if (filter === undefined || customFilterConfig === undefined) {
			return false;
		}
		const maxPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxPrice
				? customFilterConfig.maxPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxPrice
			? customFilterConfig.wdMaxPrice / 1000
			: defPriceRange.max;
		const minPrice = this.isSD
			? customFilterConfig && customFilterConfig.minPrice
				? customFilterConfig.minPrice / 1000
				: defPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMinPrice
			? customFilterConfig.wdMinPrice / 1000
			: defPriceRange.min;
		const maxDPrice = this.isSD
			? customFilterConfig && customFilterConfig.maxDeliveryPrice
				? customFilterConfig.maxDeliveryPrice / 1000
				: defDPriceRange.max
			: /*WD*/ customFilterConfig && customFilterConfig.wdMaxDeliveryPrice
			? customFilterConfig.wdMaxDeliveryPrice / 1000
			: defDPriceRange.max;
		//
		const maxLimitKM =
			customFilterConfig && customFilterConfig.maxLimitKM ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice =
			customFilterConfig && customFilterConfig.maxLimitKMPrice
				? customFilterConfig.maxLimitKMPrice / 1000 + 5
				: defLimitKMPriceRange.max;
		const minFuelC =
			customFilterConfig && customFilterConfig.minFuelC ? customFilterConfig.minFuelC : defFuelCRange.min;
		const minSeat = customFilterConfig && customFilterConfig.seatMin ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = customFilterConfig && customFilterConfig.seatMax ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = customFilterConfig && customFilterConfig.yearMin ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = customFilterConfig && customFilterConfig.yearMax ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius =
			customFilterConfig && customFilterConfig.maxRadius ? customFilterConfig.maxRadius : defRadiusRange.max;
		const sortValue = customFilterConfig && customFilterConfig.sort ? customFilterConfig.sort : "op";

		return (
			filter.minPrice > minPrice ||
			filter.maxPrice < maxPrice ||
			(filter.vehicleType && filter.vehicleType.length > 0) ||
			filter.vehicleMake != "0" ||
			filter.vehicleModel.length > 0 ||
			filter.minSeat > minSeat ||
			filter.maxSeat < maxSeat ||
			filter.minYear > minYear ||
			filter.maxYear < maxYear ||
			filter.instantBooking === true ||
			filter.dPrice < maxDPrice ||
			filter.transmission != "0" ||
			filter.features.length > 0 ||
			filter.fuel != "0" ||
			filter.fuelC > minFuelC ||
			filter.limitKM !== 0 ||
			filter.limitKMPrice < maxLimitKMPrice ||
			filter.radius * 1.60934 < maxRadius ||
			filter.sort != sortValue[0].id ||
			filter.supportIns === true ||
			filter.ownerHostFiveStar === true ||
			filter.discount === true ||
			filter.nonMortgage === true
		);
	};

	toggleSearching = () => {
		if (this.state.isOpenSearching) {
			if (this.props.carFinding.filter.address[0] == "") {
				const filter = {
					...this.props.carFinding.filter,
					address: this.state.addressBanner,
					isOpenSearching: false,
				};
				this.setFilter(filter);
			}
		}

		// WD
	
		const { locAddress, map } = this.state;
		this.initMap();
		

		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: !this.state.isOpenSearching,
		};
		this.setFilter(filter);

		this.setState(
			{
				isOpenSearching: !this.state.isOpenSearching,
			},
			() => {
				this.checkOpenSearchBox();
			}
		);
	};

	hideSearching = () => {
		this.setState({
			isOpenSearching: false,
		});
	};

	toogleSearchTime = () => {
		this.setState({
			showSearchTime: !this.state.showSearchTime,
		});
	};

	checkOpenSearchBox = () => {
		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: this.state.isOpenSearching,
		};
		this.setFilter(filter);
	};

	calculateAndDisplayRoute = (locAddress) => {
		if (mapSdk != 0) {
			this.setState(
				{
					locAddress,
				},
				() => {
					this.initMap();
				}
			);

			return;
		}
	};

	onRemoveStopPoint = (i) => {
		const { startDate, endDate, initResp, isCityTourMode } = this.state;
		const { wdOneWay } = this.props.carFinding.filter;

		const wdMinHour = isCityTourMode ? initResp.wdMinHourCT : wdOneWay ? initResp.wdMinHourOW : initResp.wdMinHour;

		const addressArray = [...this.state.addressArray];
		addressArray.splice(i, 1);
		const locationArray = [...this.state.locationArray];
		locationArray.splice(i, 1);

		// } else { // >=2 address
		if (addressArray.includes("")) {
			this.setState({
				addressArray,
				locationArray,
			});
		} else {
			// compute distance
			this.calculateAndDisplayRoute(locationArray);
			calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
				// format wdLocations
				let wdLocations = "";
				for (let i = 0; i < addressArray.length; i++) {
					wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
						"base64"
					)}${i !== addressArray.length - 1 ? "," : ""}`;
				}

				this.setState({
					err: commonErr.SUCCESS,
					addressArray,
					locationArray,
					wdLocations,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
				});
				setCookiesRoutes({ wdDistance, wdDistanceOW, wdDistanceBackOW, wdLocations });

				// across province
				let wdMinHourDetected = checkWdMinHour(
					this.state.isCityTourMode,
					wdOneWay,
					wdDistance,
					startDate,
					endDate,
					this.wdMinHour
				);
				const time = this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);
				this.setState({
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
					endDate: time.endDate,
					endTime: time.endTime,
					locAddress: locationArray,
				});

				const filter = {
					...this.props.carFinding.filter,
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
					endDate: time.endDate,
					endTime: time.endTime,
					lat: locationArray[0].lat,
					lng: locationArray[0].lng,
					wdLocations,
					wdDistance,
					wdDistanceBackOW,
				};

				this.setFilter(filter);
				this.searchCar(filter);
				cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
				cookie.save("_mmintswd", time.selectHour, { path: "/" });
			});
		}
	};

	onAddStopPoint = () => {
		const { addressArray, locationArray, isCityTourMode } = this.state;
		if (addressArray.length >= 5) return;
		if (isCityTourMode) {
			this.setState({
				isCityTourMode: false,
				addressArray: [addressArray[0], ""],
				locationArray: [locationArray[0], undefined],
				deliveryAddressChangedFlag: false,
			});
		} else {
			this.setState({
				addressArray: [...addressArray, ""],
				locationArray: [...locationArray, undefined],
			});
		}
	};

	onTripModeChange = (tripMode) => {
		let value = tripMode.isCityTourMode;
		let wdOneWay = tripMode.wdOneWay;

		const { addressArray, locationArray, wdLocations, wdDistance, deliveryAddressChangedFlag, initResp } = this.state;
		// const { wdOneWay } = this.props.carFinding.filter;
		const wdMinHour = value ? initResp.wdMinHourCT : wdOneWay ? initResp.wdMinHourOW : initResp.wdMinHour;

		if (value === false && addressArray.length === 1) return;

		if (value === true) {
			//switch to city tour

			setCookiesRoutes({ isCityTourMode: value, wdOneWay: false });

			if (addressArray[0] === "") {
				this.setState({
					isCityTourMode: value,
				});
				this.setFilter({
					...this.props.carFinding.filter,
					wdOneWay: false,
				});
			
			} else {
				this.calculateAndDisplayRoute([locationArray[0]]);

				this.setState({
					err: commonErr.SUCCESS,
					isCityTourMode: value,
				});

				const time = this.getDurationTime(value, wdMinHour, 0);
				// city tour
				// let wdMinHourDetected = checkWdMinHour(value, wdOneWay, 0, startDate, endDate, this.wdMinHour)

				this.setState({
					// wdMinHourDetected,
					locAddress: [locationArray[0]],
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
					endDate: time.endDate,
					endTime: time.endTime,
				});
				const filter = {
					...this.props.carFinding.filter,
					lat: locationArray[0].lat,
					lng: locationArray[0].lng,
					wdLocations: wdLocations.split(",")[0],
					wdDistance: 0,
					wdOneWay: false,
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
					endDate: time.endDate,
					endTime: time.endTime,
				};

				cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
				cookie.save("_mmintswd", time.selectHour, { path: "/" });

				this.setFilter(filter);
				this.searchCar(filter);

				// if (!wdMinHourDetected) {
				// 	this.searchCar(filter);
				// }
			}
		} else {
			//switch to across province

			

			if (addressArray.includes("")) {
				this.setState({
					isCityTourMode: value,
				});
				this.setFilter({
					...this.props.carFinding.filter,
					wdOneWay: wdOneWay,
				});

				setCookiesRoutes({ isCityTourMode: value, wdOneWay: wdOneWay });
				
			} else {
				this.calculateAndDisplayRoute(locationArray);

				if (deliveryAddressChangedFlag) {

					calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {

						this.setState({
							isCityTourMode: value,
							wdDistance,
							wdDistanceOW,
							wdDistanceBackOW,
							deliveryAddressChangedFlag: false,
						});
						setCookiesRoutes({
							isCityTourMode: value,
							wdDistance,
							wdDistanceOW,
							wdDistanceBackOW,
							deliveryAddressChangedFlag: false,
							wdOneWay: wdOneWay
						});

						const time = this.getDurationTime(value, wdMinHour, wdDistance);

						// across province
						// let wdMinHourDetected = checkWdMinHour(value, wdOneWay, wdDistance, startDate, endDate, this.wdMinHour)8

						this.setState({
							// wdMinHourDetected,
							locAddress: locationArray,
							selectHour: time.selectHour,
							durationTimeArr: time.durationTimeArr,
							endDate: time.endDate,
							endTime: time.endTime,
						});
						const filter = {
							...this.props.carFinding.filter,
							lat: locationArray[0].lat,
							lng: locationArray[0].lng,
							wdLocations,
							wdDistance,
							wdDistanceBackOW,
							selectHour: time.selectHour,
							durationTimeArr: time.durationTimeArr,
							endDate: time.endDate,
							endTime: time.endTime,
							wdOneWay: wdOneWay
						};

						cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
						cookie.save("_mmintswd", time.selectHour, { path: "/" });

						this.setFilter(filter);
						this.searchCar(filter);

						// if (!wdMinHourDetected) {
						// 	this.searchCar(filter);
						// }
					});
				} else {
					this.setState({
						isCityTourMode: value,
					});
					setCookiesRoutes({ isCityTourMode: value, wdOneWay: wdOneWay });

					const time = this.getDurationTime(value, wdMinHour, wdDistance);

					// across province
					// let wdMinHourDetected = checkWdMinHour(value, wdOneWay, wdDistance, startDate, endDate, this.wdMinHour)

					this.setState({
						isCityTourMode: value,
						// wdMinHourDetected,
						locAddress: locationArray,
						selectHour: time.selectHour,
						durationTimeArr: time.durationTimeArr,
						endDate: time.endDate,
						endTime: time.endTime,
					});
					const filter = {
						...this.props.carFinding.filter,
						lat: locationArray[0].lat,
						lng: locationArray[0].lng,
						wdLocations,
						wdDistance,
						selectHour: time.selectHour,
						durationTimeArr: time.durationTimeArr,
						endDate: time.endDate,
						endTime: time.endTime,
						wdOneWay: wdOneWay
					};

					cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
					cookie.save("_mmintswd", time.selectHour, { path: "/" });

					this.setFilter(filter);
					this.searchCar(filter);

					// if (!wdMinHourDetected) {
					// 	this.searchCar(filter);
					// }
				}
			}
		}
	};

	onOneWayChange = () => {
		const wdOneWay = !this.props.carFinding.filter.wdOneWay;
		const { initResp, selectHour, locationArray } = this.state;

		const wdMinHour = wdOneWay ? initResp.wdMinHourOW : initResp.wdMinHour;

		if (this.state.addressArray.includes("")) {
			setCookiesRoutes({ wdOneWay });
			this.setFilter({
				...this.props.carFinding.filter,
				wdOneWay,
			});
		} else {
			this.calculateAndDisplayRoute(locationArray);
			const { wdDistanceOW, wdDistanceBackOW, startDate, endDate } = this.state;
			const wdDistance = wdOneWay ? wdDistanceOW : wdDistanceOW + wdDistanceBackOW;
			const time = this.getDurationTime(false, wdMinHour, wdDistance);

			this.setState({
				err: commonErr.SUCCESS,
				wdDistance,
				selectHour: time.selectHour,
				durationTimeArr: time.durationTimeArr,
				endDate: time.endDate,
				endTime: time.endTime,
			});

			setCookiesRoutes({ wdOneWay, wdDistance });
			// across province
			// let wdMinHourDetected = checkWdMinHour(false, wdOneWay, wdDistance, startDate, endDate, this.wdMinHour)

			// this.setState({
			// 	wdMinHourDetected
			// })

			const filter = {
				...this.props.carFinding.filter,
				wdOneWay,
				wdDistance,
				selectHour: time.selectHour,
				durationTimeArr: time.durationTimeArr,
				endDate: time.endDate,
				endTime: time.endTime,
			};

			cookie.save("_mendtswd", time.endDate.valueOf(), { path: "/" });
			cookie.save("_mmintswd", time.selectHour, { path: "/" });

			this.setFilter(filter);
			this.searchCar(filter);
		}
	};

	showAddressBox = () => {
		// const { wdOneWay } = this.props.carFinding.filter
		// if (this.state.locAddress.length > 0) {
		// 	setTimeout(() => {
		// 		initMap(wdOneWay, this.refs, this.state.locAddress);
		// 	})
		// }

		this.initMap();

		this.setState({
			isOpenAddressBox: true,
		});
	};

	hideAddressBox = () => {
		this.setState({
			isOpenAddressBox: false,
		});
	};

	hideAllBox = () => {
		const { isSelectHour } = this.state;
		if (isSelectHour) {
			this.setState({
				isSelectHour: false,
			});
		}
		this.setState({
			isOpenAddressBox: false,
		});
	};

	formatWdAddressList = () => {
		if (this.state.isCityTourMode) {
			return this.state.addressArray[0];
		}
		var addressArray = this.state.addressArray;
		return addressArray.join(" - ");
	};

	getDurationTime = (wdMode, wdMinHour, distance) => {
		const startDate = this.state.startDate.clone();
		let durationTimeArr = getDurationTime(wdMode, wdMinHour, distance);
		let endDate = getEndDatewd(durationTimeArr[1], startDate);
		let endTime = endDate.get("hour") * 60 + endDate.get("minute");
		let selectHour = durationTimeArr[1];

		cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });
		cookie.save("_mmintswd", selectHour, { path: "/" });

		return { durationTimeArr, endDate, endTime, selectHour };
	};

	toggleDurationTimeBox = () => {
		const { isSelectHour } = this.state;

		this.setState({
			isSelectHour: !isSelectHour,
		});
	};

	handleClickSameValue = (time) => {
		// const { selectHour } = this.state;
		// if (time === selectHour) {
		// 	this.setState({
		// 		isSelectHour: false
		// 	})
		// }
		// return;
	};

	onSwitchHandleHourChange = () => {
		let { endDate } = this.state;

		this.setState({
			selectHour: 0,
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
		});

		const filter = {
			...this.props.carFinding.filter,
			selectHour: 0,
		};

		this.setFilter(filter);
		this.searchCar(filter);

		cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });
		cookie.save("_mmintswd", 0, { path: "/" });
	};

	onSelectHourChange = (e) => {
		let { endDate } = this.state;
		const selectHour = Number(e.target.value);
		const startDate = this.state.startDate;

		if (selectHour > 0) {
			endDate = getEndDatewd(selectHour, startDate);

			this.setState({
				wdMinHourDetected: undefined,
				endDate: endDate,
				endTime: endDate.get("hour") * 60 + endDate.get("minute"),
				selectHour: selectHour,
			});
		}

		this.setState({
			selectHour: selectHour,
			isSelectHour: false,
		});

		const filter = {
			...this.props.carFinding.filter,
			selectHour: selectHour,
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
		};

		this.setFilter(filter);
		this.searchCar(filter);

		cookie.save("_mendtswd", endDate.valueOf(), { path: "/" });
		cookie.save("_mmintswd", selectHour, { path: "/" });
	};

	isLogged = () => {
		const { profile } = this.props.session;
		return profile && profile.info && profile.info.uid;
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	openCalendar = () => {
		this.setState({
			isDateBox: true,
		});
	};

	closeCalendar = () => {
		this.setState({
			isDateBox: false,
		});
	};

	render() {
		var content;
		let { errMsg } = this.state;
		const {
			err,
			errMsgBox,
			isOpenSearching,
			isOpenAddressBox,
			isOpenFilter,
			isOpenFilterBox,
			isShowWdTypeInfoBox,
			isShowPopup,
			isShowAdvance,
			isCityTourMode,
			addressArray,
			addressPlaceHolder,
			addressBanner,
			wdMinHourDetected,
			viewMode,
			customFilterConfig,
			startDate,
			endDate,
			startTime,
			endTime,
			vehicleTypes,
			vehicleMakes,
			popupCarId,
			isSelectHour,
			isAirDelivery,
			wdType,
			fixHeight,
			isDateBox,
			prevUrl
		} = this.state;
		const { wdOneWay, durationTimeArr, selectHour, deliveryId } = this.props.carFinding.filter;
		const errCF = this.props.carFinding.err;

		if (wdMinHourDetected) {
			errMsg = `Thời gian thuê tối thiểu cho lộ trình trên là ${wdMinHourDetected} tiếng.`;
		}
		if (this.stype === stypes.WD && addressArray.includes("")) {
			if (addressArray.filter((address) => address === "").length > 1 && !isCityTourMode) {
				errMsg = "Vui lòng nhập điểm đón và điểm đến";
			} else if (addressArray[0] === "") {
				errMsg = "Vui lòng nhập điểm đón";
			} else if (!isCityTourMode) {
				errMsg = "Vui lòng nhập điểm đến";
			}
		}
		if (err >= commonErr.SUCCESS && errMsg === "") {
			if (viewMode === viewModes.MAP) {
				content = (
					<div className="map-carfinding">
						<MapView
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCarMapMore={this.searchCarMapMore}
							setAddressPlaceHolder={this.setAddressPlaceHolder}
							togglePopup={this.togglePopup}
							stype={this.stype}
						/>
						<QuicklyFilter
							visible={this.visible}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isSD={this.isSD}
							toggleFilterBox={this.toggleFilterBox}
							viewMode={viewMode}
						/>
					</div>
				);
			} else {
				content = (
					<>
						<QuicklyFilter
							visible={this.visible}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isSD={this.isSD}
							toggleFilterBox={this.toggleFilterBox}
							viewMode={viewMode}
						/>
						<ListView
							visible={this.visible}
							isAirDelivery={isAirDelivery}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							counters={this.props.carFinding.counters}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							searchCarListMore={this.searchCarListMore}
							togglePopup={this.togglePopup}
							isLogged={this.isLogged()}
							showLoginForm={this.openLoginForm}
							stype={this.stype}
						/>
					</>
				);
			}
		} else {
			content = (
				<div className="list-car-section">
					<Empty img={empty} msg={errMsg !== "" ? errMsg : "Đã có lỗi xảy ra. Vui lòng thử lại."} />
				</div>
			);
		}

		const addressName = this.formatWdAddressList();

		return (
			<React.Fragment>
				<Helmet>
					<meta
						name="keywords"
						content="thuê xe có lái, thuê xe 7 chỗ có tài xế, thuê xe có tài xế, thuê xe 4 chỗ có tài xế, giá thuê xe 7 chỗ có tài xế, cần thuê xe 4 chỗ có tài xế, cần thuê xe 7 chỗ có tài xế, thuê xe có tài, thuê xe có tài xế hà nội, cho thuê xe có tài, thuê xe ô tô có tài xế, thuê xe 7 chỗ có tài, thuê xe có tài xế tphcm, thuê xe có tài xế đà nẵng"
					/>
				</Helmet>

				<div className="mioto-layout">
					<Header fixed={viewMode === viewModes.LIST ? true : false} visible={this.visible} />

					<section className={`body ${isOpenFilter || isOpenSearching || fixHeight ? "fix-height" : ""}`}>
						{/* Start Mobile */}
						<SearchFilterBox
							visible={this.visible}
							isSD={false}
							address={this.props.carFinding.filter.address}
							addressBanner={addressBanner}
							addressPlaceHolder={addressPlaceHolder}
							startDate={this.props.carFinding.filter.startDate}
							endDate={this.props.carFinding.filter.endDate}
							formatWdAddress={addressName}
							setMapView={this.setMapView}
							setListView={this.setListView}
							viewMode={viewMode}
							toggleSearching={this.toggleSearching}
							toggleFilter={this.toggleFilter}
							resetFilter={this.resetFilter}
							filter={this.props.carFinding.filter}
							customFilterConfig={customFilterConfig}
							hasFilter={this.hasFilter}
							prevUrl={prevUrl}
						/>
						<QuicklySearchWD
							visible={this.visible}
							viewMode={viewMode}
							addressPlaceHolder={addressPlaceHolder}
							addressBanner={addressBanner}
							startDate={startDate}
							endDate={endDate}
							isIOS={isIOS}
							WDCalendarTemplate={WDCalendarTemplate}
							wrapperSelectCF={this.wrapperSelectCF}
							isSelectHour={isSelectHour}
							selectHour={selectHour}
							durationTimeArr={durationTimeArr}
							showAddressBox={this.showAddressBox}
							formatWdAddress={addressName}
							onStartDateChange={this.onStartDateChange}
							toggleDurationTimeBox={this.toggleDurationTimeBox}
							onSelectHourChange={this.onSelectHourChange}
							onEndDateChange={this.onEndDateChange}
							openCalendar={this.openCalendar}
							startTime={startTime}
							endTime={endTime}
							prevUrl={prevUrl}
						/>
						{content}
						{/* <div className="result-info"> 
							{this.props.carFinding.total > 0 && <span>Đã tìm thấy <span className="number">{this.props.carFinding && this.props.carFinding.total} <span className="result">kết quả</span></span></span>}
							<div className="right-side"></div>
						</div> */}
						{viewMode === viewModes.LIST ? (
							<div className={`show-list-map ${this.visibleBottom ? "" : "scroll-bottom"}`} onClick={this.setMapView}>
								<p>Bản đồ</p>
								<div className="wrap-svg">
									<IcMapCarFinding />
								</div>
							</div>
						) : (
							<div className="show-list-map" onClick={this.setListView}>
								<p>Danh sách</p>
								<div className="wrap-svg">
									<IcListCarFinding />
								</div>
							</div>
						)}
					</section>

					{isDateBox && (
						<DateBoxWD
							startDate={startDate}
							endDate={endDate}
							startTime={startTime}
							endTime={endTime}
							finding={true}
							onStartTimeChange={this.onStartTimeChange}
							onEndTimeChange={this.onEndTimeChange}
							onStartDateChange={this.onStartDateChange}
							onDatesChange={this.onEndDateChange}
							show={isDateBox}
							isMCalendar={true}
							hideModal={this.closeCalendar}
							wrapperSelect={this.wrapperSelectCF}
							toggleDurationTimeBox={this.toggleDurationTimeBox}
							onSelectHourChange={this.onSelectHourChange}
							selectHour={selectHour}
							durationTimeArr={durationTimeArr}
							isSelectHour={isSelectHour}
							filter={this.props.carFinding.filter}
							searchCar={this.searchCar}
						/>
					)}

					<SearchBox
						isShow={isOpenSearching}
						hide={this.hideSearching}
						isSD={false}
						address={this.props.carFinding.filter.address}
						wd={this.props.carFinding.wd}
						map={this.map}
						startDate={startDate}
						endDate={endDate}
						startTime={startTime}
						endTime={endTime}
						addressArray={addressArray}
						wdOneWay={wdOneWay}
						isCityTourMode={isCityTourMode}
						selectHour={selectHour}
						durationTimeArr={durationTimeArr}
						isSelectHour={isSelectHour}
						WDCalendarTemplate={WDCalendarTemplate}
						WDECalendarTemplate={WDECalendarTemplate}
						isIOS={isIOS}
						onTripModeChange={this.onTripModeChange}
						onOneWayChange={this.onOneWayChange}
						onAddStopPoint={this.onAddStopPoint}
						onRemoveStopPoint={this.onRemoveStopPoint}
						showWdTypeInfoBox={this.showWdTypeInfoBox}
						onAddressChange={this.onAddressChange}
						onAddressFocus={this.onAddressFocus}
						onSelectAddress={this.onSelectAddress}
						toggleDurationTimeBox={this.toggleDurationTimeBox}
						onStartDateChange={this.onStartDateChange}
						onEndDateChange={this.onEndDateChange}
						onStartTimeChange={this.onStartTimeChange}
						onEndTimeChange={this.onEndTimeChange}
						onSelectHourChange={this.onSelectHourChange}
						wrapperRef={this.wrapperSelectCF}
					/>

					{isOpenFilterBox && (
						<FilterPopup
							isShow={isOpenFilterBox}
							hide={this.hideFilterBox}
							vehicleType={this.props.carFinding.filter.vehicleType}
							viewModes={viewModes}
							viewMode={viewMode}
							defPriceRange={defPriceRange}
							defLimitKMRange={defLimitKMRange}
							defLimitKMPriceRange={defLimitKMPriceRange}
							defYearRange={defYearRange}
							defSeatRange={defSeatRange}
							defRadiusRange={defRadiusRange}
							defFuelCRange={defFuelCRange}
							defDPriceRange={defDPriceRange}
							filter={this.props.carFinding.filter}
							counters={this.props.carFinding.counters}
							customFilterConfig={customFilterConfig}
							vehicleTypes={vehicleTypes}
							vehicleMakes={vehicleMakes}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
							searchCar={this.searchCar}
							isShowAdvance={isShowAdvance}
							showMessageBox={this.showMessageBox}
							hideMessageBox={this.hideMessageBox}
							showAdvance={this.showAdvance}
							hideAdvance={this.hideAdvance}
							stype={this.stype}
						/>
					)}

					<FilterScreen
						isShow={isOpenFilter}
						hide={this.hideFilter}
						vehicleType={this.props.carFinding.filter.vehicleType}
						viewModes={viewModes}
						viewMode={viewMode}
						defPriceRange={defPriceRange}
						defLimitKMRange={defLimitKMRange}
						defLimitKMPriceRange={defLimitKMPriceRange}
						defYearRange={defYearRange}
						defSeatRange={defSeatRange}
						defRadiusRange={defRadiusRange}
						defFuelCRange={defFuelCRange}
						defDPriceRange={defDPriceRange}
						filter={this.props.carFinding.filter}
						counters={this.props.carFinding.counters}
						customFilterConfig={customFilterConfig}
						vehicleTypes={vehicleTypes}
						vehicleMakes={vehicleMakes}
						setFilter={this.setFilter}
						resetFilter={this.resetFilter}
						searchCar={this.searchCar}
						isShowAdvance={isShowAdvance}
						showMessageBox={this.showMessageBox}
						hideMessageBox={this.hideMessageBox}
						showAdvance={this.showAdvance}
						hideAdvance={this.hideAdvance}
						stype={this.stype}
					/>

					{isOpenAddressBox && (
						<RouteBox
							onHide={this.hideAddressBox}
							map={this.map}
							show={isOpenAddressBox}
							addressArray={addressArray}
							wdOneWay={wdOneWay}
							isCityTourMode={isCityTourMode}
							filter={this.props.carFinding.filter}
							onTripModeChange={this.onTripModeChange}
							onSelectAddress={this.onSelectAddress}
							onAddressChange={this.onAddressChange}
							onAddressFocus={this.onAddressFocus}
							onOneWayChange={this.onOneWayChange}
							onAddStopPoint={this.onAddStopPoint}
							onRemoveStopPoint={this.onRemoveStopPoint}
							showWdTypeInfoBox={this.showWdTypeInfoBox}
							wd={this.props.carFinding.wd}
							isShowWdTypeInfoBox={isShowWdTypeInfoBox}
							hideWdTypeInfoBox={this.hideWdTypeInfoBox}
							errMsgBox={errMsgBox}
							hideMessageBox={this.hideMessageBox}
						/>
					)}
					<MessageBox show={errMsgBox !== ""} hideModal={this.hideMessageBox} message={errMsgBox} />
					<WdTypeInfoBox show={isShowWdTypeInfoBox} hideModal={this.hideWdTypeInfoBox} wdType={wdType} />
					{isShowPopup ? (
						<CarDetailPopup
							show={isShowPopup}
							onHide={this.onHidePopup}
							togglePopup={this.togglePopup}
							carId={popupCarId}
							stype={this.stype}
							deliveryId={deliveryId}
						/>
					) : null}
					<Login
							show={this.state.showLoginForm}
							showModal={this.openLoginForm}
							hideModal={this.closeLoginForm}
							openSignupForm={this.openSignupForm}
							getLoggedProfile={this.getLoggedProfile}
					/>
					<SignUp
						show={this.state.showSignup}
						showModal={this.openSignupForm}
						hideModal={this.closeSignupForm}
						openLoginForm={this.openLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
				</div>
			</React.Fragment>
		);
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
		session: state.session,
	};
}

CarFindingWD = connect(mapState)(CarFindingWD);
export default CarFindingWD;
